/* This file is autogenerated, see readme.md for instructions */
import ClearSvgIcon from '@bloomreach/banana-theme/icons/clear.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ClearIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ClearSvgIcon />
    </Icon>
  );
});

ClearIcon.displayName = 'ClearIcon';

export default ClearIcon;
